import React from 'react';
import { ApplicantApproval } from '../models';
import { Colors, PrimaryButton, SizeableRoundedDialog, Text } from 'library';
import { WorkerAvatar } from 'parent-portal/providers/cards/shared/WorkerAvatar';
import { Grid } from '@mui/material';
import { format12HourTime, formatShortWeekdayMonthDay } from 'shared/Dates';

export default function ApplicantApprovalMoreDetails({
    applicant,
    open,
    onClose,
}: {
    applicant: ApplicantApproval;
    open: boolean;
    onClose: () => void;
}) {
    return (
        <SizeableRoundedDialog open={open} onClose={onClose} closeButton contentStyle={{ padding: 0 }}>
            <Grid container sx={{ backgroundColor: Colors.lightRed, height: 80, marginBottom: 6 }} padding={2}>
                <WorkerAvatar src={applicant.applied_user.pictureUrl} />
                <Text variant="h1" bold textStyle={{ marginTop: 16, marginLeft: 10 }}>
                    {applicant.applied_user.name}
                </Text>
            </Grid>
            <Grid container flexDirection="column" padding={2} marginTop={4}>
                <Text bold>Days Requested</Text>
                {applicant.days_applied.map((day) => (
                    <Text variant="body2" key={day.id}>
                        {formatShortWeekdayMonthDay(day.start)}
                    </Text>
                ))}
            </Grid>
            <Grid container flexDirection="column" padding={2}>
                <Text bold>Schedule Changes Requested</Text>
                {applicant.autobook_reasons.attributes.review_times.length === 0 ? (
                    <Text variant="body2">{applicant.applied_user.name} requested to work the schedule as posted.</Text>
                ) : (
                    applicant.autobook_reasons.attributes.review_times.map((time) => (
                        <>
                            <Text variant="body2" key={time.start}>
                                {formatShortWeekdayMonthDay(time.start)}, {format12HourTime(time.start, time.timezone)}{' '}
                                - {format12HourTime(time.end, time.timezone, true)}{' '}
                            </Text>
                            <Text variant="caption" color={Colors.mediumRed}>
                                posted time{' '}
                                {`${format12HourTime(time.appointment_start, time.timezone)} - ${format12HourTime(time.appointment_end, time.timezone)}`}
                            </Text>
                        </>
                    ))
                )}
            </Grid>
            <Grid container flexDirection="column" padding={2}>
                <Text bold>Missing Requirements</Text>
                {applicant.autobook_reasons.attributes.unqualified.length === 0 ? (
                    <Text variant="body2">{applicant.applied_user.name} meets all base requirements for this job.</Text>
                ) : (
                    applicant.autobook_reasons.attributes.unqualified.map((qualification) => (
                        <Text variant="body2" key={qualification}>
                            {qualification}
                        </Text>
                    ))
                )}
            </Grid>
            <Grid container justifyContent="flex-end">
                <PrimaryButton onClick={onClose} buttonStyle={{ width: 'auto', marginRight: 20, marginBottom: 20 }}>
                    Done
                </PrimaryButton>
            </Grid>
        </SizeableRoundedDialog>
    );
}
